import * as yup from "yup";

export const manualSubscriptionValidationSchema = yup.object().shape({
    userId: yup
        .string()
        .required("User ID is required")
        .test("is-number", "User ID must be a number", (val) => !val || !isNaN(Number(val))),
    planId: yup
        .string()
        .required("Plan is required")
        .test("is-number", "Plan ID must be a number", (val) => !val || !isNaN(Number(val))),
    startFrom: yup.string().required("Start date is required"),
});
